import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-full w-full flex-col items-center justify-center px-4" }
const _hoisted_2 = { class: "w-full max-w-[28rem] rounded-[1.8rem] border-[10px] border-jm_orange bg-jm_dark_green px-6 py-7 text-center text-jm_white shadow-2xl shadow-black/30" }
const _hoisted_3 = { class: "text-[24px] font-bold uppercase leading-tight" }
const _hoisted_4 = { class: "mt-4 whitespace-pre-line text-[16px] leading-snug" }
const _hoisted_5 = { class: "mt-6 rounded-2xl border-2 border-jm_orange bg-black/20 p-4 text-left text-[15px] font-bold leading-snug" }
const _hoisted_6 = { class: "flex cursor-pointer items-start gap-3" }
const _hoisted_7 = ["disabled"]

import { ref } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { useGlobalStore } from "@/stores/global";
import { useGameTracking } from "@/composables/useGameTracking";


export default /*@__PURE__*/_defineComponent({
  __name: 'termsAcceptance',
  setup(__props) {

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();
const accepted = ref(false);
const isSubmitting = ref(false);

const continueToGame = async () => {
  if (!accepted.value || isSubmitting.value) {
    return;
  }

  isSubmitting.value = true;
  globalStore.acceptLegalConditions(true);
  globalStore.playBackgroundMusic();
  kpiTracker.setConfirmedConsent(true);

  try {
    await session.updateSessionProgress(kpiTracker.getKpiData(), {
      step: "terms_accepted",
    });
  } catch {
    // Tracking failures should not block a user who accepted the legal terms.
  } finally {
    isSubmitting.value = false;
  }

  globalStore.changeStep("shotAnimation");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("legal_acceptance.title")), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("legal_acceptance.description")), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((accepted).value = $event)),
                type: "checkbox",
                class: "mt-1 h-5 w-5 shrink-0 accent-jm_orange"
              }, null, 512), [
                [_vModelCheckbox, accepted.value]
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("legal_acceptance.checkbox_prefix")), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "ml-8 mt-2 block text-left font-bold leading-snug text-jm_orange underline decoration-2 underline-offset-4",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(globalStore).openTermsAndConditions('termsAcceptance')), ["stop"]))
            }, _toDisplayString(_ctx.$t("legal_acceptance.checkbox_link")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "mt-6 w-full rounded-xl bg-jm_orange px-6 py-3 text-sm font-bold uppercase text-white transition-opacity disabled:cursor-not-allowed disabled:opacity-45",
            disabled: !accepted.value || isSubmitting.value,
            onClick: continueToGame
          }, _toDisplayString(_ctx.$t("legal_acceptance.continue_button")), 9, _hoisted_7)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})